import axios from 'axios';
import * as qs from 'qs';
import { appConfig } from 'config';
const apiRoot = `${appConfig.onboardApi}/api`;
export async function http({ method, url, data, accessToken, params, apiService, headers }) {
    const config = {
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            ...headers
        },
        method,
        url: apiService ?? apiRoot + url,
        withCredentials: apiService?.includes('/admin'),
        params,
        paramsSerializer(p) {
            return qs.stringify(p, { arrayFormat: 'repeat' });
        },
        data
    };
    if (accessToken)
        config.headers.Authorization =
            `Bearer ${accessToken}`;
    const result = await axios.request(config);
    return result.data;
}
